import { Drawer } from '@/components/ui';

import { AdminChangesProvider } from './adminChanges';
import { AdminPanel } from './AdminPanel';

/** Die Administration als Schublade (REQ-25 §4.1) — Nachfolger von `AdminSidebar`. */
export interface AdminDrawerProps {
  open: boolean;
  onClose: () => void;
  /** Eine Änderung betrifft die Navigation (Views, Kategorien, Gruppen) — neu laden. */
  onNavigationChanged?: () => void;
}

/**
 * `80rem` statt der 600px des Altclients: Die Feldliste einer View braucht den Platz
 * (ChinaApp REQ-043). Auf schmalen Fenstern deckelt `Drawer` die Breite selbst.
 */
const WIDTH = '80rem';

export function AdminDrawer(props: AdminDrawerProps) {
  return (
    <Drawer
      id="iwm-admin-drawer"
      open={props.open}
      onClose={props.onClose}
      title="Administration"
      description="Benutzer, Berechtigungen, Views und Auswahllisten"
      width={WIDTH}
    >
      <AdminChangesProvider onNavigationChanged={props.onNavigationChanged}>
        <AdminPanel />
      </AdminChangesProvider>
    </Drawer>
  );
}

export default AdminDrawer;
